import { eventBus } from '@codestreet/event-bus'

import { EVENT_BUS_CONTEXT, EVENT_BUS_TARGET } from './config'

export function generateEventBusName(command: string): string {
  return eventBus.nameGenerate(EVENT_BUS_CONTEXT, EVENT_BUS_TARGET, command)
}
